import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const getStudyNote = createAsyncThunk(
  "study/getStudyNote",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { ticker_name } = formInfo;
      const res = await api.get(`study/note/${encodeURIComponent(ticker_name)}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const saveStudyNote = createAsyncThunk(
  "study/saveStudyNote",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { ticker_name, content } = formInfo;
      const res = await api.put(`study/note/${encodeURIComponent(ticker_name)}`, { content });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteStudyNote = createAsyncThunk(
  "study/deleteStudyNote",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { ticker_name } = formInfo;
      const res = await api.delete(`study/note/${encodeURIComponent(ticker_name)}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getStudyNoteTickers = createAsyncThunk(
  "study/getStudyNoteTickers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("study/notes/tickers");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getWatchlist = createAsyncThunk(
  "study/getWatchlist",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("study/watchlist");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const addToWatchlist = createAsyncThunk(
  "study/addToWatchlist",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { ticker_name } = formInfo;
      const res = await api.post("study/watchlist", { ticker_name });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const removeFromWatchlist = createAsyncThunk(
  "study/removeFromWatchlist",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { ticker_name } = formInfo;
      const res = await api.delete(`study/watchlist/${encodeURIComponent(ticker_name)}`);
      return { ...res.data, removed_ticker: ticker_name };
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
